export default {
    Fastball: {color: '#D22D49', strokeColor: 'rgb(147, 31, 51)', short: '직구', name: '직구'},
    Slider: {color: '#EEE716', strokeColor: 'rgb(167, 162, 15)', short: '슬라', name: '슬라이더'},
    ChangeUp: {color: '#1DBE3A', strokeColor: 'rgb(20, 133, 41)', short: '체인', name: '체인지업'},
    Curveball: {color: '#00D1ED', strokeColor: 'rgb(0, 146, 166)', short: '커브', name: '커브'},
    Sinker: {color: '#FE9D00', strokeColor: 'rgb(178, 110, 0)', short: '킥체', name: '킥체인지업'},
    Forkball: {color: '#3BACAC', strokeColor: 'rgb(41, 120, 120)', short: '포크', name: '포크'},
    Splitter: {color: '#3BACAC', strokeColor: 'rgb(41, 120, 120)', short: '포크', name: '포크'},
    Cutter: {color: '#933F2C', strokeColor: 'rgb(103, 44, 31)', short: '커터', name: '커터'},
    Sweeper: {color: '#DDB33A', strokeColor: 'rgb(155, 125, 41)', short: '스위', name: '스위퍼'},
    Knuckleball: {color: '#3C44CD', strokeColor: 'rgb(42, 48, 144)', short: '너클', name: '너클볼'},
    Other: {color: '#000', strokeColor: '#000', short: '기타', name: '기타'},
    '-': {color: '#000', strokeColor: '#000', short: '기타', name: '기타'}
};